document.addEventListener('DOMContentLoaded', function () {
  function formatCLP() {
    document.querySelectorAll('price-list').forEach(function (el) {
      el.querySelectorAll('*').forEach(function (child) {
        child.childNodes.forEach(function (node) {
          if (node.nodeType === Node.TEXT_NODE && /,\d{3}/.test(node.textContent)) {
            node.textContent = node.textContent.replace(/,(\d{3})/g, '.$1');
          }
        });
      });
    });
  }

  formatCLP();

  const observer = new MutationObserver(formatCLP);
  observer.observe(document.body, { childList: true, subtree: true });
});
